import ApiClient from "../helpers/ApiClient";
import useSWR from "swr";

const fetcher = (url) => ApiClient.get(url).then((res) => res.data);

export function useAssets(filters = {}) {
  const queryParams = new URLSearchParams(filters).toString();
  const APIURL = `/assets${queryParams ? `?${queryParams}` : ''}`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

export function useAssetDetails(id) {
  const APIURL = id ? `/assets/${id}` : null;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

export function useAssetCategories() {
  const APIURL = `/assets/categories`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

export function useAssetDashboard() {
  const APIURL = `/assets/dashboard`;
  const { data, error, isLoading, mutate } = useSWR(APIURL, fetcher);
  return {
    data,
    error,
    isLoading,
    mutate,
  };
}

export async function createAsset(data) {
  const response = await ApiClient.post("/assets", data);
  return response.data;
}

export async function updateAsset(id, data) {
  const response = await ApiClient.put(`/assets/${id}`, data);
  return response.data;
}

export async function createAssetCategory(data) {
  const response = await ApiClient.post("/assets/categories", data);
  return response.data;
}

export async function transferAsset(data) {
  const response = await ApiClient.post("/assets/transfers", data);
  return response.data;
}

export async function recordMaintenance(data) {
  const response = await ApiClient.post("/assets/maintenance", data);
  return response.data;
}

export async function disposeAsset(data) {
  const response = await ApiClient.post("/assets/dispose", data);
  return response.data;
}

export async function runDepreciation() {
  const response = await ApiClient.post("/assets/depreciate");
  return response.data;
}
